import type { RouteObject } from 'react-router';

import { EmbedSearchWidgetLayoutLoadable } from 'modules/embedSearchWidget/layouts/layout/EmbedSearchWidgetLayoutLoadable';
import * as embedApplyToVolopHorizonRouteExports from 'modules/embedSearchWidget/pages/volops/applyTo/EmbedSearchWidgetApplyToVolop.horizon-route';
import * as embedSearchVolopsHorizonRouteExports from 'modules/embedSearchWidget/pages/volops/search/EmbedSearchWidgetSearchVolops.horizon-route';
import * as embedViewVolopHorizonRouteExports from 'modules/embedSearchWidget/pages/volops/view/EmbedSearchWidgetViewVolop.horizon-route';
import { horizonRouteToObject } from 'routing/utils/horizonRouteToObject';

import {
  embedSearchWidgetApplyToVolopRoute,
  embedSearchWidgetSearchVolopsRoute,
  embedSearchWidgetViewVolopRoute,
} from './embedSearchWidget.routes';

export const embedSearchWidgetRouteObjects = [
  {
    Component: EmbedSearchWidgetLayoutLoadable,
    children: [
      {
        path: embedSearchWidgetSearchVolopsRoute.fullPath,
        ...horizonRouteToObject(embedSearchVolopsHorizonRouteExports),
      },
      {
        path: embedSearchWidgetViewVolopRoute.fullPath,
        ...horizonRouteToObject(embedViewVolopHorizonRouteExports),
      },
      {
        path: embedSearchWidgetApplyToVolopRoute.fullPath,
        ...horizonRouteToObject(embedApplyToVolopHorizonRouteExports),
      },
    ],
  },
] satisfies RouteObject[];
